export default "__VITE_ASSET__d25d1c67__"